<template>
  <section class="main">
    <h1 class="intro">{{ $t("HOW_TO_UNLINK") }}</h1>
    <div class="row">
      <div class="unlink">
        <p class="g-text">
          {{ $t("UNLINK_STEPS") }}
        </p>
        <ul class="steps">
          <li class="step">
            <span class="step__header">
              <span class="step__num">1</span>
              {{ $t("OPEN_SETTINGS_GENERAL") }}
            </span>
            <img class="step__screen" src="@/assets/unlink1.png" />
          </li>
          <li class="step">
            <span class="step__header">
              <span class="step__num">2</span>
              {{ $t("UNLINK_STEPS_1") }}
            </span>
            <img class="step__screen" src="@/assets/unlink2.png" />
          </li>
          <li class="step">
            <span class="step__header">
              <span class="step__num">3</span>
              {{ $t("UNLINK_STEPS_2") }}
            </span>
            <img class="step__screen" src="@/assets/unlink3.png" />
          </li>
          <li class="step">
            <span class="step__header">
              <span class="step__num">4</span>
              {{ $t("UNLINK_STEPS_3") }}
            </span>
            <img class="step__screen" src="@/assets/unlink4.png" />
          </li>
          <li class="step">
            <span class="step__header">
              <span class="step__num">5</span>
              {{ $t("UNLINK_STEPS_4") }}
            </span>
            <img class="step__screen" src="@/assets/unlink5.png" />
          </li>
          <li class="step">
            <span class="step__header step__header_noal">
              <span class="step__num">6</span>
              {{ $t("UNLINK_STEPS_5") }}
            </span>
          </li>
        </ul>
      </div>
      <div class="pc">
        <h2 class="pc__title">{{ $t("UNLINK_YOUR_PC") }}</h2>
        <p class="g-text">
          {{ $t("IT_WILL_ALSO_BE_UNLINKED") }}
        </p>
        <button class="pc__button" @click="unlink">{{ $t("UNLINK") }}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    title() {
      return this.$t('HOW_TO_UNLINK');
    },
  },
  methods: {
    unlink() {
      this.$store.commit('lt', '');
      this.$store.commit('setDevices', []);
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.row {
  display: flex;
  align-items: flex-start;
}

.pc {
  background: #fbfbfb;
  border-radius: 8px;
  padding: 10px;
  margin-left: 15px;
  flex: 0 0 200px;

  @include notebook {
    display: none;
  }

  &__title {
    color: $text-primary;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  &__button {
    background: #fff5f5;
    border: 1px solid rgba(250, 101, 101, 0.5);
    border-radius: 2px;
    padding: 5px 20px;
    margin-top: 10px;
    font-size: 14px;
    display: inline-block;
  }
}

.steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 15px;

  @include notebook {
    justify-content: flex-start;
  }
}

.step {
  width: 32%;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;

  @include notebook {
    max-width: 300px;
    width: 100%;
    height: auto;
    margin-right: 15px;
  }

  &__screen {
    width: 100%;
    height: auto;
    margin-top: 10px;
  }

  &__header {
    display: flex;
    align-items: center;

    &:not(&_noal) {
      margin: auto 0;
    }
  }

  &__num {
    background: #525d66;
    height: 20px;
    flex: 0 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    color: #fff;
    font-size: 12px;
    margin-right: 4px;
  }
}
</style>
